module.exports = __webpack_public_path__ + "static/download.afd1559a.png";